import { useTranslation } from 'react-i18next';
import PersonIcon from '@mui/icons-material/Person';
import { PractitionersForm, Practitioner } from 'components/EventForms';
import { Box } from '@mui/material';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { SectionTitle } from '@insights-ltd/design-library/components';
import EditFormNavigation from './EditFormNavigation';
import { EditProps } from './types';

const EditPractitioners = ({
  eventForm,
  onCancel,
  saveEvent,
  saving,
}: EditProps) => {
  const { t } = useTranslation();
  const onSubmit = (formData: Practitioner[]) => {
    saveEvent({ practitioners: formData });
  };
  return (
    <>
      <Box
        sx={{
          mt: spacingSizeMap.L,
          mb: spacingSizeMap.L,
        }}
      >
        <SectionTitle
          icon={{ icon: <PersonIcon />, iconColour: 'pink' }}
          text={t('ui.event-management.events.edit.practitioners.header')}
        />
      </Box>
      <PractitionersForm event={eventForm} onSubmit={onSubmit}>
        <EditFormNavigation onCancel={onCancel} saving={saving} />
      </PractitionersForm>
    </>
  );
};

export default EditPractitioners;
